export default function SVGMore(props: any) {
    return (
        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                id="Rectangle 50144"
                d="M1.1998 1L6.85665 6.65685L1.1998 12.3137"
                stroke="#2B6EFF"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
